/**
 * @description: 打印机设置
 * @author: cyp
 * @update: fire (2017-10-27 13:30)
 * @update: hwx
 * @update: lyr
 */
<template>
<div class="printer-manage">
	<div class="printer-list" v-show="showList">
		<div class="row row-margin">
			<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addPrinter">添加打印机</button>
			<button type="button" class="btn bg-orange btn-flat bigbtn sub-margin" @click="setPageParams">商品总单打印设置</button>
		</div>
		<div class="row row-margin">
			<label class="list-label-2">门店:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="printer_shop" data-placeholder="请选择门店"></select>
			</div>
			<label class="list-label-4">包厢区域:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="printer_boxarea" data-placeholder="请选择包厢区域" disabled></select>
			</div>
			<label class="list-label-2">状态:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="printer_status">
					<option value="">全部</option>
					<option value="1">启用</option>
					<option value="-1">禁用</option>
				</select>
			</div>
			<label class="list-label-5">打印机名称:</label>
			<div class="col-md-2">
				<input class="form-control" placeholder="请输入打印机别名" v-model="printer_name">
			</div>
			<div class="pull-right">
				<button type="button" class="btn bg-orange btn-flat btn-wide" @click="queryList()">查询</button>
			</div>
		</div>
		<p>注：若未指定打印机且未设置默认打印机时，有多台打印机同时符合单次打印需求，则系统自动指定从打印机ID大的打印</p>
		<div class="table-responsive">
			<table ref="printer_list" class="table table-bordered table-hover" data-pagination="true"></table>
		</div>
	</div>
	<!-- 添加、修改打印机 -->
	<div class="printer-edit" v-show="showdetail">
		<div class="page-tit">{{edit_tit}}</div>
		<p class="row-margin">
			注：打印区域和打印包厢只能设置一个<br />
			手机/平板/一体机上设置指定打印机不受【打印区域，商品属性，是否一菜一单，默认打印机】设置的影响
		</p>
		<div class="row">
			<label class="ctr-label-left">门店:</label>
			<div class="col-md-4 ct-col">
				<select class="form-control" ref="edit_shop" data-placeholder="请选择门店">
				</select>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印机ip:</label>
			<div class="col-md-4">
			    <input class="form-control" v-model.trim="edit_ip"  placeholder="请填写打印机ip地址">
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印机名称:</label>
			<div class="col-md-4">
				<input class="form-control " v-model.trim="edit_else_name" placeholder="请输入打印机别名，例如：一楼厨房打印机">
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">收银机名称:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly" placeholder="请选择收银机名称" v-model="edit_cash_txt" ref="edit_cash_txt" readonly="readonly" @click="editCashFun($event)" />
				<span class="selection-clear" @click="clearInput('edit_cash_txt')">×</span>
				<span class="span-arrow" role="presentation"><b></b></span>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印机类型:</label>
			<div class="col-md-4 ct-col">
				<select class="form-control" data-placeholder="请选择打印机类型" ref="edit_type">
					<option value="1">热敏打印机（80mm）</option>
					<option value="2">针式打印机（80mm）</option>
					<option value="3">平推打印机（140mm）</option>
				</select>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印区域:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly canselect" placeholder="请选择需要打印的区域范围" v-model="edit_area" ref="edit_area" readonly @click="editAreaFun($event)" />
				<span class="selection-clear" @click="clearInput('edit_area')">×</span>
				<span class="span-arrow" role="presentation"><b></b></span>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印包厢:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly canselect" placeholder="请选择需要打印的包厢范围" v-model="edit_box" ref="edit_box" readonly @click="editBoxFun($event)">
				<span class="selection-clear" @click="clearInput('edit_box')">×</span>
				<span class="span-arrow" role="presentation"><b></b></span>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">备货单商品属性:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly" v-model="edit_bh_attr" ref="edit_bh_attr" placeholder="请选择需要打印的商品属性" readonly @click="openBhAttr()">
				<span class="selection-clear" @click="clearInput('edit_bh_attr')">×</span>
				<span class="span-arrow" role="presentation">
				<b role="presentation"></b></span>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">备货单来源设置:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly" placeholder="请选择类型设置" v-model="edit_bh_from" ref="edit_bh_from" @click="openBhFrom($event)" readonly>
				<span class="selection-clear" @click="clearInput('edit_bh_from')">×</span>
				<span class="span-arrow" role="presentation"><b></b></span>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">打印份数:</label>
			<div class="col-md-4 ct-col">
				<select class="form-control" data-placeholder="请设置打印份数" ref="edit_print_num">
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
				</select>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">使用时间:</label>
			<div class="col-md-4">
				<input class="form-control input-readonly" placeholder="请选择可使用时间" v-model="edit_use_time" ref="edit_use_time" @click="openUseTime($event)" readonly>
			</div>
		</div>
		<div class="row">
			<label class="ctr-label-left">是否一菜一单:</label>
			<div class="col-md-4" style="line-height: 32px;">
				<input id="ismenu_1" type="radio" name="ismenu" class="radiobig" value="1" v-model="ismenu">
				<label class="control-label" for="ismenu_1">总分单</label>
				<input id="ismenu_2" type="radio" name="ismenu" class="radiobig" value="2" v-model="ismenu" style="margin-left: 19px;">
				<label class="control-label" for="ismenu_2">一菜一单</label>
				<input id="ismenu_3" type="radio" name="ismenu" class="radiobig" value="3" v-model="ismenu" style="margin-left: 19px;">
				<label class="control-label" for="ismenu_3">一菜一单+总分单</label>
		    </div>
			<span class="rmarkspan" titles="一菜一单的意思是一个商品需要打印一张备货单</br>例如:</br>如果一个订单里面有10个商品需要备货的</br>如果选择【总分单】指打印1张10个商品的备货单，共1张</br>如果选择【一菜一单】指分别打印10张1个商品的备货单，共10张" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
		</div>
		<div class="row">
			<label class="ctr-label-left">默认打印机:</label>
			<div class="col-md-4" style="line-height: 32px;">
				<input id="is_default_printer_no" type="radio" name="is_default_printer" class="radiobig" value="-1" v-model="is_default_printer">
				<label class="control-label" for="is_default_printer_no">否</label>
				<input id="is_default_printer_yes" type="radio" name="is_default_printer" class="radiobig" value="1" v-model="is_default_printer" style="margin-left: 30px;">
				<label class="control-label" for="is_default_printer_yes">是</label>
			</div>
			<span class="rmarkspan" titles="使用没有设置打印机的平板/手机操作订单时候从默认打印机打印出纸质单" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
		</div>
		<div class="row">
			<label class="ctr-label-left">选择打印单据:</label>
			<div class="edit-print-bill col-md-8" style="line-height: 32px;">
				<p>
					总单：<br />
					1，根据智慧商家app指定的收银机出单据。<br />
					2，若智慧商家app没有指定收银机的话根据默认打印机出单据。<br />
					3，若未指定收银机且未设置默认打印机时，则从打印机ID大出单据。
				</p>
				<div class="row">
					<input type="checkbox" v-model="print_all" @click="printAll">
					<label>全选</label>
				</div>
				<ul class="clearfix">
					<li class="col-md-4" v-for="item in print_all_arr" :key="item.id">
						<input type="checkbox" v-model="print_all_item" :value="item.id">
						<label for="">{{item.name}}</label>
					</li>
				</ul>
				<p>
					分单：<br />
					1，符合商品属性，打印区域，打印包厢，有勾选则出分单，没勾选不出单<br />
					2，转房单（分单），有勾选，则有操作转房则都会出分单
				</p>
				<div class="row">
					<input type="checkbox" v-model="print_singer" @click="printSinger">
					<label>全选</label>
				</div>
				<ul class="clearfix">
					<li class="col-md-4" v-for="item in print_singer_arr" :key="item.id">
						<input type="checkbox" v-model="print_singer_item" :value="item.id">
						<label for="">{{item.name}}</label>
					</li>
				</ul>
			</div>
		</div>

		<div class="row" style="padding-top: 30px;">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
			<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editSave(modify)">保存</button>
		</div>
	</div>
	<!-- 收银机名称 -->
	<div class="ele-hide" ref="cash_alert">
		<div class="multi-select">
			<div class="clearfix">
				<input type='checkbox' v-model='cash_all' @click='cashCheckAll'>
				<span>全选</span>
			</div>
			<ul class="clearfix">
				<li v-for="item in cash_arr" :key="item.id">
					<input type="checkbox" v-model='cash_item' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
	</div>
	<!-- 打印区域 -->
	<div class="ele-hide" ref="printer_area">
		<div class="multi-select">
			<div class="clearfix">
				<input type='checkbox' v-model='area_all' @click='areaCheckAll'>
				<span>全选</span>
			</div>
			<ul class="clearfix">
				<li v-for="item in area_arr" :key="item.id">
					<input type="checkbox" v-model='area_item' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
	</div>
	<!-- 包厢区域 -->
	<div class="multi-page" ref="box_area" v-show="showBox">
		<div class="page-tit">打印包厢范围</div>
		<p>请选择打印机需要打印的包厢范围</p>
		<div class="multi-page-main">
			<div class="multi-page-row" v-for="items in box_arr" :key="items.room_area">
				<div>
					<span>{{items.room_area_name}}</span>
				</div>
				<ul class="clearfix">
					<li v-for="item in items.room" :key="item.id">
						<input type="checkbox" v-model='box_item' :value="item.id">
						<span>{{item.name}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="row">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backEdit">返回</button>
			<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="boxSave">确定</button>
		</div>
	</div>
	<!-- 备货单商品属性 -->
	<div class="ele-hide" ref="bh_attr_wrap">
		<div class="multi-select">
			<div class="clearfix">
				<input type='checkbox' v-model='bh_attr_all' @click='bhAttrAll'>
				<span>商品类型</span>
			</div>
			<ul class="clearfix">
				<li v-for="item in bh_attr_arr" :key="item.id">
					<input type="checkbox" v-model='bh_attr_item' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
		<div class="multi-select" v-show="flower_type_list.length>0">
			<div class="clearfix">
				<input type='checkbox' v-model='bh_flower_all' @click='bhFlowerAll'>
				<span>花类型</span>
			</div>
			<ul class="clearfix">
				<li v-for="item in flower_type_list" :key="item.id">
					<input type="checkbox" v-model='flower_type' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
	</div>
	<!-- 备货单来源设置 -->
	<div class="bh-from-wrap" ref="bh_from_wrap">
		<ul>
			<li>
				<input type="checkbox" id="bhFromAll" v-model='bh_from_all' @click="bhFromAll">
				<label for="bhFromAll">全选</label>
			</li>
			<li>
				<input type="checkbox" id="1" v-model="bh_from_item" value="1">
				<label for="1">微信自助下单</label>
			</li>
			<li>
				<input type="checkbox" id="2" v-model="bh_from_item" value="2">
				<label for="2">触摸屏员工下单</label>
			</li>
			<li>
				<input type="checkbox" id="3" v-model="bh_from_item" value="3">
				<label for="3">app下单（安卓一体机）</label>
				<ul>
					<li>
						<input type="checkbox" id="6" v-model="bh_from_child" value="6">
						<label for="6">开房套餐</label>
					</li>
					<li>
						<input type="checkbox" id="7" v-model="bh_from_child" value="7">
						<label for="7">点单收银</label>
					</li>
				</ul>
			</li>
			<li>
				<input type="checkbox" id="4" v-model="bh_from_item" value="4">
				<label for="4">app下单（非一体机）</label>
			</li>
			<li>
				<input type="checkbox" id="5" v-model="bh_from_item" value="5">
				<label for="5">商品赠送总单</label>
			</li>
		</ul>
	</div>
	<!-- 账单打印二维码 -->
	<div class="qrcode-det" v-show="showCode">
		<div class="qrcode-header">注：点鼠标右键可以保存账单打印二维码</div>
		<div class="qrcode-con">
			<img src="" alt="" ref="qrcode_img">
		</div>
		<div class="row" style="padding-top: 30px;">
			<button type="button" class="btn btn-flat btn-middle btn-orange" @click="backFun">返回</button>
		</div>
	</div>
	<!-- 使用时间选择 -->
	<div class="use-time-wrap" ref="printer_use_time">
		<h2>开始时间：</h2>
		<select ref="printer_starthour"></select>
		<label class="colon">:</label>
		<select ref="printer_startseconds"></select>
		<h2>结束时间：</h2>
		<select ref="printer_stophour"></select>
		<label class="colon">:</label>
		<select ref="printer_stopseconds"></select>
	</div>
</div>
</template>

<script>
	import * as types from '@/store/types';
	import Vue from 'vue';
	export default {
	name: 'printer-manage',
	data() {
		return {
			showList: true,
			showdetail: false,
			showBox: false,
			showCode: false,
			printer_store_menu: {},
			modify: 1,
			printer_name: "",
			thePrinter: {
				type: Object
			},
			edit_tit: "添加打印机",
			edit_ip: "", // 打印机ip
			edit_else_name: "",
			edit_cash_txt: "",
			cash_all: false,
			cash_item: [],
			cash_arr: [],
			edit_area: "",
			area_all: false,
			c_area_all: false,
			area_item: [],
			area_arr: [],
			edit_box: "",
			box_item: [],
			box_arr: [],
			box_detarr: [],
			edit_bh_attr: "",
			bh_attr_all: false,
			c_bh_attr_all: false,
			bh_attr_item: [],
			bh_attr_arr: [],
			edit_bh_from: '',
			bh_from_all: false,
			c_bh_from_all: false,
			bh_from_item: [],
			bh_from_child: [],
			bh_from_arr: [{id: '1', name: '微信自助下单'}, {id: '2', name: '触摸屏员工下单'}, {id: '3', name: 'app下单（安卓一体机）'}, {id: '4', name: 'app下单（非一体机）'}, {id: '5', name: '商品赠送总单'}],
			edit_use_time: '',
			use_start_time: '',
			use_end_time: '',
			ismenu: 1,
			is_default_printer: -1,
			print_all: false,
			c_print_all: false,
			print_all_arr: [],
			print_all_item: [],
			print_singer: false,
			c_print_singer: false,
			print_singer_arr: [],
			print_singer_item: [],
			flower_type_list: [], // 全部花单类型
			flower_type: [],
			bh_flower_all: false,
		}
	},
	computed: {
		menunew() {
			return JSON.parse(this.$store.state.menunew)
		}
	},
	watch: {
		cash_item: {
			handler: function(val, oldVal) {
				if(this.cash_item.length >= this.cash_arr.length) {
					this.cash_all = true;
					this.c_cash_all = true;
				} else {
					this.cash_all = false;
					this.c_cash_all = false;
				}
			},
			deep: true
		},
		edit_area: {
			handler: function(val, oldval) {
				if(val != "") {
					$(this.$refs.edit_box).addClass("canselect");
					$(this.$refs.edit_area).parent().find('.selection-clear').show();
				} else {
					$(this.$refs.edit_box).removeClass("canselect");
					$(this.$refs.edit_area).parent().find('.selection-clear').hide();
				}
			},
			deep: true
		},
		area_item: {
			handler: function(val, oldVal) {
				if(this.area_item.length >= this.area_arr.length) {
					this.area_all = true;
					this.c_area_all = true;
				} else {
					this.area_all = false;
					this.c_area_all = false;
				}
			},
			deep: true
		},
		edit_box: {
			handler: function(val, oldval) {
				if(val != "") {
					$(this.$refs.edit_area).addClass("canselect");
					$(this.$refs.edit_box).parent().find('.selection-clear').show();
				} else {
					$(this.$refs.edit_area).removeClass("canselect");
					$(this.$refs.edit_box).parent().find('.selection-clear').hide();
				}
			},
			deep: true
		},
		bh_attr_item: {
			handler: function(val, oldVal) {
				if(this.bh_attr_item.length >= this.bh_attr_arr.length) {
					this.bh_attr_all = true;
					this.c_bh_attr_all = true;
				} else {
					this.bh_attr_all = false;
					this.c_bh_attr_all = false;
				}
			},
			deep: true
		},
		flower_type: {
			handler: function(val, oldval) {
				if (this.flower_type.length >= this.flower_type_list.length) {
					this.bh_flower_all = true
				}else {
					this.bh_flower_all = false
				}
			},
			deep: true
		},
		edit_bh_from: {
			handler: function(val, oldval) {
				if(val != "") {
					$(this.$refs.edit_bh_from).parent().find('.selection-clear').show();
				} else {
					$(this.$refs.edit_bh_from).parent().find('.selection-clear').hide();
				}
			},
			deep: true
		},
		bh_from_item: {
			handler: function (val, oldVal) {
				if(this.bh_from_item.length >= this.bh_from_arr.length) {
					this.bh_from_all = true;
					this.c_bh_from_all = true;
				} else {
					this.bh_from_all = false;
					this.c_bh_from_all = false;
				}
				if(this.bh_from_item.indexOf('3') == '-1') {
					this.bh_from_child = [];
				} else {
					if(this.bh_from_child.length == '0') {
						this.bh_from_child = ['6', '7'];
					}
				}
			},
			deep: true
		},
		bh_from_child: {
			handler: function (val, oldVal) {
				let _this = this;
				if(val.length != '0') {
					if(_this.bh_from_item.indexOf('3') == '-1') {
						_this.bh_from_item.push('3');
					}
				} else {
					let index = _this.bh_from_item.indexOf('3');
					if(index != '-1') {
						_this.bh_from_item.splice(index, 1);
					}
				}
			},
			deep: true
		},
		edit_bh_attr: {
			handler: function(val, oldval) {
				if(val != "") {
					$(this.$refs.edit_bh_attr).parent().find('.selection-clear').show();
				} else {
					$(this.$refs.edit_bh_attr).parent().find('.selection-clear').hide();
				}
			},
			deep: true
		},
		print_all_item: {
			handler: function(val, oldVal) {
				if(this.print_all_item.length >= this.print_all_arr.length) {
					this.print_all = true;
					this.c_print_all = true;
				} else {
					this.print_all = false;
					this.c_print_all = false;
				}
			},
			deep: true
		},
		print_singer_item: {
			handler: function(val, oldVal) {
				if(this.print_singer_item.length >= this.print_singer_arr.length) {
					this.print_singer = true;
					this.c_print_singer = true;
				} else {
					this.print_singer = false;
					this.c_print_singer = false;
				}
			},
			deep: true
		},
	},
	mounted: function() {
		// 跳转菜单
		this.getPageMenu();
		this.$nextTick(function() {
			let _this = this;

			_this.getShopData();
			$(this.$refs.printer_status).select2({
				minimumResultsForSearch: -1,
				language: "zh-CN"
			});
			$(this.$refs.edit_type).select2({
				allowClear: true,
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			});
			$(this.$refs.edit_print_num).select2({
				allowClear: true,
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			});

			_this.printBillList();
			_this.initPrinterTime();
			_this.getBhAttr();
			_this.getFlowerTypeList();
		});
	},
	methods: {
		// 跳转菜单
		getPageMenu: function() {
			this.menunew.forEach(i => {
				if(i.id == '546') {
					i.submenu.forEach(j => {
						if(j.id == '570') {
							// 门店设置
							this.printer_store_menu = j
						}
					})
				}
			})
		},
		// 跳转参数
		setPageParams() {
			const obj = {
				name: 'store_set',
				params: {
					url_name: 'print',
					url_index: '1'
				}
			}
			this.$emit("pageLink", this.printer_store_menu, obj)
		},
		// 修改页的提示语
		hint_language: function(e) {
			var contents="<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
			layer.tips(contents,$(e.currentTarget),{
				skin: 'hint_language_tip',
				tips: [2, '#fff'],
				time: 2000000,
			});
		},
		// 关闭提示语
		close_hint_language: function() {
			layer.closeAll('tips');
		},
		// 获取门店
		getShopData: function() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						let arr = [];
						$.each(data.response.result, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.printer_shop).select2({
							data: arr,
							allowClear: true,
							minimumResultsForSearch: -1,
							language: "zh-CN"
						}).on("select2:select", function(e) {
							if(e.params.data.text == "全部") {
								$(_this.$refs.printer_boxarea).html("");
								$(_this.$refs.printer_boxarea).prop("disabled", true);
								return;
							}
							$(_this.$refs.printer_boxarea).prop("disabled", false);
							_this.getBoxArea(e.params.data.id);
						});
						$(_this.$refs.printer_shop).val(data.response.result[1].id).trigger('change');
						$(_this.$refs.printer_boxarea).prop("disabled", false);
						_this.getBoxArea($(_this.$refs.printer_shop).val());

						_this.innitable();

						arr.shift();
						$(_this.$refs.edit_shop).select2({
							data: arr,
							allowClear: true,
							minimumResultsForSearch: -1,
							language: "zh-CN",
							width: '100%'
						}).on("select2:select", function(e) {
							_this.getCashData(e.params.data.id);
							_this.edit_cash_txt = '';
							_this.cash_item = [];
							_this.getBoxArea(e.params.data.id, false);
							_this.edit_area = '';
							_this.area_item = [];
							$(_this.$refs.edit_area).removeClass("canselect");
							_this.getBox(e.params.data.id);
							_this.edit_box = '';
							_this.box_item = [];
							$(_this.$refs.edit_box).removeClass("canselect");
						});
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
				}
			});
		},
		getBoxArea: function(shop_id, type) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": shop_id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Shop/getRoomArea",
				async: false,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						let arr = [{ id: " ", text: "全部" }];
						if(type == false) {
							_this.area_arr = data['response']['result'];
							return;
						}
						$.each(data['response']['result'], function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.printer_boxarea).html("");
						$(_this.$refs.printer_boxarea).select2({
							data: arr,
							minimumResultsForSearch: -1,
							language: "zh-CN"
						});
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦')
				}
			});
		},
		innitable: function() {
			let _this = this;

			$(_this.$refs.printer_list).bootstrapTable('destroy');
			$(_this.$refs.printer_list).bootstrapTable({
				pageSize: 10,
				pageList: [],
				ajax: function(params) {
					_this.getPrinterList(params);
				},
				sidePagination: "server",
				pagination: true,
				columns: [{
					width: "6%",
					field: "id",
					title: "打印机ID"
				}, {
					width: "8%",
					field: "shop_name",
					title: "门店"
				}, {
					width: "8%",
					field: "room_area_name",
					title: "区域"
				}, {
					width: "8%",
					field: "room_name",
					title: "包厢号"
				}, {
					width: "8%",
					field: "printer_name",
					title: "打印机名称"
				}, {
					width: "6%",
					field: "status_name",
					title: "状态"
				}, {
					width: "15%",
					title: "操作",
					events: {
						'click .oper': function(e, value, row, index) {
							let status = (row.status == 1) ? "-1" : "1";
							_this.onOffPrinter(row.id, status);
						},
						'click .update': function(e, value, row, index) {
							_this.modify = 2;
							_this.edit_tit = "修改打印机";
							_this.getPrinterDetail(row.id);
							_this.showList = false;
							_this.showdetail = true;
						},
						'click .qrcode': function(e, value, row, index) {
							_this.showList = false;
							_this.showCode = true;
							$(_this.$refs.qrcode_img).prop('src', row.qrcode).change('trigger');
						},
					},
					formatter: function(value, row, index) {
						let status_name = (row.status == 1) ? "禁用" : "启用";
						return '<span class="text-blue oper">'+ status_name +'</span>&nbsp;&nbsp;<span class="text-blue update">修改</span>&nbsp;&nbsp;<span class="text-blue qrcode">账单打印二维码</span>'
					}
				}],
			});
		},
		getPrinterList: function(params) {
			let _this = this,
				pageNumber = 1;

			if(params.data.offset != 0) {
				pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
			}
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"page": pageNumber,
						"page_size": "10",
						"shop_id": $(_this.$refs.printer_shop).val(),
						"room_area": $.trim($(_this.$refs.printer_boxarea).val()),
						"status": $.trim($(_this.$refs.printer_status).val()),
						"printer_name": _this.printer_name
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Printer/getPrinterList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code']=="true"){
						params.success({
							total: data['response']['result']['total'],
							rows: data['response']['result']['rows']
						});
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
						params.success({
							total: 0,
							rows: []
						});
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		// 点击“查询”按钮
		queryList: function() {
			this.innitable();
		},
		// 禁用、启用
		onOffPrinter: function(id, status) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"id": id,
						"status": status
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Printer/onOffPrinter",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code']=="true"){
						$(_this.$refs.printer_list).bootstrapTable('refresh');
						layer.msg(data["response"]["error_msg"]);
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		addPrinter: function() {
			this.modify = 1;
			this.edit_tit = "添加打印机";
			$(this.$refs.edit_shop).prop("disabled", false);
			$(this.$refs.edit_shop).val('').trigger('change');
			this.edit_ip = "";
			this.edit_else_name = "";
			this.getCashData($(this.$refs.edit_shop).val());
			this.edit_cash_txt = '';
			this.cash_item = [];
			$(this.$refs.edit_type).val('').trigger("change");
			this.getBoxArea($(this.$refs.edit_shop).val(), false);
			this.edit_area = "";
			this.area_item = [];
			$(this.$refs.edit_area).removeClass("canselect");
			this.edit_box = "";
			this.box_item = [];
			$(this.$refs.edit_box).removeClass("canselect");
			this.getBox($(this.$refs.edit_shop).val());
			this.edit_bh_attr = "";
			this.bh_attr_item = [];
			this.flower_type = [];
			this.edit_bh_from = '';
			this.bh_from_item = [];
			$(this.$refs.edit_print_num).val('').trigger("change");
			this.edit_use_time = '';
			this.use_start_time = '';
			this.use_end_time = '';
			this.ismenu = 1;
			this.is_default_printer = -1;
			this.print_all_item = [];
			this.print_singer_item = [];

			this.showList = false;
			this.showdetail = true;
		},
		// 获取收银机列表
		getCashData: function(shop_id) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"version": Vue.version,
					"param": {
						"shop_id": shop_id
					}
				},
				"comment": ""
			};
			let datas2 = JSON.stringify(datas);
			$.ajax({
				type: "post",
				dataType: "json",
				url: Vue.ctUrl + "Setting/getShopCheckstandListByPrinter",
				crossDomain: true,
				async: false,
				xhrFields: {
					withCredentials: true
				},
				data: {
					json: datas2
				},
				success: function(data) {
					if(data.response.result_code == "true") {
						_this.cash_arr = data['response']['result'];
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data.response.error_msg);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		editCashFun: function() {
			let _this = this;
			let c_cash_item = _this.cash_item;

			layer.confirm('', {
				skin: 'public-alert-skin',
				type: 1,
				btn: ['确定', '取消'], // 按钮
				title: ['选择收银机', true],
				area: ['700px', ''], // 宽高
				content: $(_this.$refs.cash_alert),
				cancel: function() {
					// 右上角关闭
					if(_this.edit_cash_txt != "") {
						_this.cash_item = c_cash_item;
						return;
					}
					_this.cash_item = [];
				}
			}, function() {
				let texts = [];
				_this.cash_arr.forEach(function(item) {
					_this.cash_item.forEach(function(item2) {
						if(item.id == item2) {
							texts.push(item.name);
						}
					});
				});
				_this.edit_cash_txt = texts.join(",");
				layer.closeAll();
			}, function() {
				if(_this.edit_cash_txt != "") {
					_this.cash_item = c_cash_item;
					return;
				}
				_this.cash_item = [];
			});
		},
		// 收银机全选
		cashCheckAll: function() {
			let _this = this;

			_this.cash_all = _this.c_cash_all;
			if (!_this.cash_all) { // 实现全选
				_this.cash_item = [];
				_this.cash_arr.forEach(function(item) {
					_this.cash_item.push(item.id);
				});
			} else { // 实现反选
				_this.cash_item = [];
			}
		},
		// 打开区域
		editAreaFun: function(e) {
			let _this = this;

			let c_area_item = _this.area_item;
			if(!$(e.currentTarget).hasClass('canselect')) {
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['打印区域', true],
					area: ['700px', ''], //宽高
					content: $(_this.$refs.printer_area),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_area != "") {
							_this.area_item = c_area_item;
							return;
						}
						_this.area_item = [];
					}
				}, function() {
					let texts = [];
					_this.area_arr.forEach(function(item) {
						_this.area_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_area = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_area != "") {
						_this.area_item = c_area_item;
						return;
					}
					_this.area_item = [];
				});
			}
		},
		// 区域全选
		areaCheckAll: function() {
			let _this = this;
			_this.area_all = _this.c_area_all;
			if (!_this.area_all) { // 实现全选
				_this.area_item = [];
				_this.area_arr.forEach(function(item) {
					_this.area_item.push(item.id);
				});
			} else { // 实现反选
				_this.area_item = [];
			}
		},
		// 获取包厢号
		getBox: function(shop_id) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": shop_id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Shop/getAllRoomByArea",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.box_arr = data['response']['result'];
						let newarray = [];
						$.each(data['response']['result'], function(k, v) {
							$.each(v.room, function(m, n) {
								newarray.push(n);
							});
						});
						_this.box_detarr = newarray;
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		editBoxFun: function(e) {
			if(!$(e.currentTarget).hasClass('canselect')) {
				let _this = this;
				_this.showdetail = false;
				_this.showBox = true;
			}
		},
		boxSave:function() {
			let _this = this;
			let texts = [];
			_this.box_detarr.forEach(function(item) {
				_this.box_item.forEach(function(item2) {
					if(item.id == item2) {
						texts.push(item.name);
					}
				});
			});
			_this.edit_box = texts.join(",");
			_this.showdetail = true;
			_this.showBox = false;
		},
		backEdit:function() {
			this.showdetail = true;
			this.showBox = false;
		},
		// 获取备货单商品属性
		getBhAttr: function() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "PublicData/api_getGoodsType",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.bh_attr_arr = data['response']['result']['data'];
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		// 获取备货属性花单类型
		getFlowerTypeList() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"page": 0,
						"page_size": 0,
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Flower/getTypeList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.flower_type_list = data.response.result.rows;
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		openBhAttr: function(e) {
			let _this = this;
			let c_bh_attr_item = _this.bh_attr_item;
			let c_flower_type = _this.flower_type;
			layer.confirm('', {
				skin: 'public-alert-skin',
				type: 1,
				btn: ['确定', '取消'], // 按钮
				title: ['备货单商品属性', true],
				area: ['700px', ''], // 宽高
				content: $(_this.$refs.bh_attr_wrap),
				cancel: function() {
					// 右上角关闭
					if(_this.edit_bh_attr != "") {
						_this.bh_attr_item = c_bh_attr_item;
						_this.flower_type = c_flower_type;
						return;
					}
					_this.bh_attr_item = [];
					_this.flower_type = [];
				}
			}, function() {
				let texts = [];
				_this.bh_attr_arr.forEach(function(item) {
					_this.bh_attr_item.forEach(function(item2) {
						if(item.id == item2) {
							texts.push(item.name);
						}
					});
				});
				_this.flower_type.forEach(item => {
					_this.flower_type_list.forEach(v => {
						if (v.id == item) {
							texts.push(v.name)
						}
					})
				})
				_this.edit_bh_attr = texts.join(",");
				layer.closeAll();
			}, function() {
				if(_this.edit_bh_attr != "") {
					_this.bh_attr_item = c_bh_attr_item;
					_this.flower_type = c_flower_type;
					return;
				}
				_this.bh_attr_item = [];
				_this.flower_type = [];
			});
		},
		// 商品属性全选
		bhAttrAll: function() {
			let _this = this;
			_this.bh_attr_all = _this.c_bh_attr_all;
			if(!_this.bh_attr_all) { // 实现全选
				_this.bh_attr_item = [];
				_this.bh_attr_arr.forEach(function(item) {
					_this.bh_attr_item.push(item.id);
				});
			} else { // 实现反选
				_this.bh_attr_item = [];
			}
		},
		// 花单类型全选
		bhFlowerAll: function() {
			let _this = this;
			if(!_this.bh_flower_all) { // 实现全选
				_this.flower_type = [];
				_this.flower_type_list.forEach(function(item) {
					_this.flower_type.push(item.id);
				});
			} else { // 实现反选
				_this.flower_type = [];
			}
		},
		// 打开备货单来源选项
		openBhFrom: function() {
			let _this = this;

			let c_bh_from_item = _this.bh_from_item;
			layer.confirm('', {
				skin: 'add_goods-alert',
				type: 1,
				btn: ['确定', '取消'],
				title: ['备货单来源', true],
				area: ['560px', ''],
				content: $(_this.$refs.bh_from_wrap),
				offset: '100px',
				cancel: function() {
					// 右上角关闭
					if(_this.edit_bh_from != "") {
						_this.bh_from_item = c_bh_from_item;
						return;
					}
					_this.bh_from_item = [];
				}
			}, function() {
				let arr = [];
				_this.bh_from_arr.forEach(function(item) {
					_this.bh_from_item.forEach(function(item2) {
						if(item.id == item2) {
							arr.push(item.name);
						}
					});
				});
				_this.edit_bh_from = arr.join(",");
				layer.closeAll();
			}, function() {
				if(_this.edit_bh_from != "") {
					_this.bh_from_item = c_bh_from_item;
					return;
				}
				_this.bh_from_item = [];
			});
		},
		// 全选
		bhFromAll: function() {
			let _this = this;

			_this.bh_from_all = _this.c_bh_from_all;
			if(!_this.bh_from_all) { // 实现全选
				_this.bh_from_item = [];
				_this.bh_from_arr.forEach(function(item) {
					_this.bh_from_item.push(item.id);
				});
			} else { // 实现反选
				_this.bh_from_item = [];
			}
		},
		// 获取时间
		initPrinterTime: function() {
			let _this = this;
			let seconds = [];
			for(let i = 0; i < 60; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				seconds[i] = item;
			};
			let hour = [];
			for(let i = 0; i < 24; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				hour[i] = item;
			}
			$(_this.$refs.printer_starthour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.printer_startseconds).select2({
				data: seconds,
				language: "zh-CN"
			});
			$(_this.$refs.printer_stophour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.printer_stopseconds).select2({
				data: seconds,
				language: "zh-CN"
			});
		},
		// 使用时间
		openUseTime: function() {
			let _this = this;

			$(_this.$refs.printer_starthour).val(_this.use_start_time.split(':')[0]).trigger('change');
			$(_this.$refs.printer_startseconds).val(_this.use_start_time.split(':')[1]).trigger('change');
			$(_this.$refs.printer_stophour).val(_this.use_end_time.split(':')[0]).trigger('change');
			$(_this.$refs.printer_stopseconds).val(_this.use_end_time.split(':')[1]).trigger('change');
			layer.confirm('', {
				type: 1,
				skin: 'public-alert-skin',
				btn: ['确定', '取消'], //按钮
				title: '使用时间选择',
				area: ['450px', ''], //宽高
				content:$(this.$refs.printer_use_time),
			}, function() {
				let starthour = $(_this.$refs.printer_starthour).select2("val");
				let startseconds = $(_this.$refs.printer_startseconds).select2("val");
				let stophour = $(_this.$refs.printer_stophour).select2("val");
				let stopseconds = $(_this.$refs.printer_stopseconds).select2("val");
				_this.use_start_time = starthour + ":" + startseconds;
				_this.use_end_time = stophour + ":" + stopseconds;
				_this.edit_use_time = _this.use_start_time + " - " + _this.use_end_time ;
				layer.close(layer.index);
			});
		},
		// 总单、分单列表
		printBillList: function() {
			let _this = this;
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Printer/getBillTypeList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.print_all_arr = data.response.result.bill_type;
						_this.print_singer_arr = data.response.result.second_bill_type;
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		// 清空多选
		clearInput: function(name) {
			if(name == "edit_cash_txt") {
				this.edit_cash_txt = "";
				this.cash_item = [];
			} else if(name == "edit_area") {
				this.edit_area = "";
				this.area_item = [];
			} else if(name == "edit_box") {
				this.edit_box = "";
				this.box_item = [];
			} else if(name == "edit_bh_attr") {
				this.edit_bh_attr = "";
				this.bh_attr_item = [];
				this.flower_type = [];
			} else if(name == "edit_bh_from") {
				this.edit_bh_from = '';
				this.bh_from_item = [];
			}
		},
		// 返回
		backFun: function() {
			this.showCode = false;
			this.showdetail = false;
			this.showList = true;
		},
		// 总单全选
		printAll: function() {
			let _this = this;
			_this.print_all = _this.c_print_all;
			if(!_this.print_all) { // 实现全选
				_this.print_all_item = [];
				_this.print_all_arr.forEach(v => {
					_this.print_all_item.push(v.id);
				});
			} else { // 实现反选
				_this.print_all_item = [];
			}
		},
		// 分单全选
		printSinger: function() {
			let _this = this;
			_this.print_singer = _this.c_print_singer;
			if(!_this.print_singer) { // 实现全选
				_this.print_singer_item = [];
				_this.print_singer_arr.forEach(v => {
					_this.print_singer_item.push(v.id);
				});
			} else { // 实现反选
				_this.print_singer_item = [];
			}
		},
		// 新增、修改
		editSave: function(modify) {
			let _this = this;

			if(_this.edit_ip == '') {
				layer.msg('请填写打印机ip地址');
				return false;
			} else if(_this.area_item.length == '0' && _this.box_item.length == '0') {
				layer.msg('请选择包厢区域或包厢号');
				return false;
			}
			let pathurl = "";
			let order_source = _this.bh_from_item.concat(_this.bh_from_child);
			let print_rule = _this.print_all_item.concat(_this.print_singer_item);
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": $(_this.$refs.edit_shop).val(),
						"print_ip": _this.edit_ip,
						"printer_name": _this.edit_else_name,
						"checkstand_id": _this.cash_item,
						"print_type": $(_this.$refs.edit_type).val(),
						"room_area": _this.area_item,
						"room_id": _this.box_item,
						"goods_type": _this.bh_attr_item,
						"flower_type": _this.flower_type,
						"order_source": order_source,
						"num": $(_this.$refs.edit_print_num).val(),
						"start_time": _this.use_start_time,
						"end_time": _this.use_end_time,
						"type": _this.ismenu,
						"default_printer": _this.is_default_printer,
						"print_rule": print_rule,
					}
				},
				"comment": ""
			};
			if(modify == "1") {
				pathurl = 'addPrinter';
			} else {
				pathurl = 'updatePrinter';
				datas["request"]["param"]["id"] = this.thePrinter.id;
			}
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Printer/" + pathurl,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						layer.confirm("打印机设置修改后需重启打印服务程序才能生效，请手动重启一体机打印服务程序。", {
							btn: ['好的，我知道了'],
							closeBtn: 0
						}, function() {
							layer.msg(data["response"]["error_msg"]);
							$(_this.$refs.printer_list).bootstrapTable('refresh');
							_this.showList = true;
							_this.showdetail = false;
						});
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		// 详情
		getPrinterDetail: function(id) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"id": id,
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Printer/getPrinterDetail",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code']=="true"){
						let datas = data['response']['result'];
						_this.thePrinter = datas;
						$(_this.$refs.edit_shop).prop("disabled", true);
						$(_this.$refs.edit_shop).val(datas.shop_id).trigger("change");
						_this.edit_ip = datas.print_ip;
						_this.edit_else_name = datas.printer_name;
						_this.getCashData(datas.shop_id);
						_this.edit_cash_txt = datas.checkstand_name;
						_this.cash_item = datas.checkstand_id;
						$(_this.$refs.edit_type).val(datas.print_type).trigger("change");
						if(datas.room_area_name != "") {
							_this.getBoxArea(datas.shop_id, false);
							_this.edit_area = datas.room_area_name;
							_this.area_item = datas.room_area;
							$(_this.$refs.edit_area).removeClass("canselect");

							_this.edit_box = '';
							_this.box_item = [];
							$(_this.$refs.edit_box).addClass("canselect");
						} else if(datas.room_name != "") {
							_this.getBox(datas.shop_id);
							_this.edit_box = datas.room_name;
							_this.box_item = datas.room_id;
							$(_this.$refs.edit_box).removeClass("canselect");

							_this.edit_area = '';
							_this.area_item = [];
							$(_this.$refs.edit_area).addClass("canselect");
						}
						_this.edit_bh_attr = datas.goods_type_name + (datas.flower_type_name == '' ? '' : (',' + datas.flower_type_name));
						_this.bh_attr_item = datas.goods_type;
						_this.flower_type = datas.flower_type;
						_this.edit_bh_from = datas.order_source_name;
						_this.bh_from_item = [];
						_this.bh_from_child = [];
						$.each(datas.order_source, function(k, v) {
							if(v == '6' || v == '7') {
								_this.bh_from_child.push(v);
							} else {
								_this.bh_from_item.push(v);
							}
						});
						$(_this.$refs.edit_print_num).val(datas.num).trigger("change");
						// 使用时间
						_this.use_start_time = datas.start_time;
						_this.use_end_time = datas.end_time;
						_this.edit_use_time = datas.start_time + ' - ' + datas.end_time;
						_this.ismenu = datas.type;
						_this.is_default_printer = datas.default_printer;
						// 总单
						_this.print_all_item = [];
						_this.print_all_arr.forEach(v => {
							if(datas.print_rule.includes(String(v.id))) {
								_this.print_all_item.push(v.id)
							}
						});
						// 分单
						_this.print_singer_item = [];
						_this.print_singer_arr.forEach(v => {
							if(datas.print_rule.includes(String(v.id))) {
								_this.print_singer_item.push(v.id)
							}
						});
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {}
			});
		},
	}
}
</script>
<style lang="less">
	.printer-manage {
		p {
			color: #FF0707;
		}
		.printer-edit {
			.control-label {
				text-align: right;
				line-height: 32px;
				font-size: 14px;
				font-weight: normal;
				color: #5e5e5e;
				padding-left: 0;
				padding-right: 0;
			}
			.canselect {
				background-color:#eee!important;
			}
			.edit-print-bill {
				input {
					float: left;
					margin: 9px 6px 0 0;
				}
				label {
					float: left;
					margin: 0;
				}
			}
		}
		.qrcode-det {
			.qrcode-header {
				padding: 0 290px 0 0;
				color: #FC2F54;
				font-size: 16px;
				text-align: center;
			}
			.qrcode-con {
				width: 500px;
				min-height: 556px;
				border: 1px solid #DDD;
				margin: 50px auto;
			}
			.qrcode-con img {
				display: block;
				width: 80%;
				margin: 50px auto 70px;
			}
		}
		.bh-from-wrap {
			display: none;
			padding: 30px 20px;
			font-size: 14px;
			>ul {
				width: 37%;
				margin: 0 auto;
				>li {
					margin: 0 0 15px;
					ul {
						margin: 0 30px 0;
						li {
							margin: 10px 0 0;
						}
					}
				}
				label {
					margin: 0 0 0 6px;
				}
			}
		}
		.use-time-wrap {
			.select2 {
				width: 150px!important;
			}
		}
	}
</style>